import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import EditOpportunitySecurityChecklistWindowDescription from './EditOpportunitySecurityChecklistWindowDescription';

class OpportunitySearchParams extends SearchParamsBase {
  static saveType = 'OpportunitySearchParams';
  initialize() {
    this.OpportunityName = '';
    // this.OpportunityId = "";
    this.ClientId = '';
    this.UseFollowUpDateRange = false;
    this.FollowUpDateOnOrAfter = dateTimeHelper.indefiniteDateValue();
    this.FollowUpDateOnOrBefore = dateTimeHelper.indefiniteDateValue();
    this.StatusCode = [];
    this.UninvoicedOtherFees = false;
    this.OwningOffices = [];
    this.IsGlobal = '';
    this.IsMultiOffice = '';
    this.PrimarySalesRep = '';
    this.Owner = '';
    this.AssignedTo = '';
    this.Industry = '';
    this.UseCreatedOnDateRange = false;
    this.CreatedOnOrAfter = dateTimeHelper.indefiniteDateValue();
    this.CreatedOnOrBefore = dateTimeHelper.indefiniteDateValue();
    this.OpportunityType = [];
    this.ApprovedLogoUsage = '';
    this.ApprovedNameUsage = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'ClientId', label: 'Client Name or Id', className: 'col-4', type: InputTypesEnum.Text },
    // { fieldName: "OpportunityId", label: "Opportunity Id", className: "col-4", type: InputTypesEnum.Number },
    { fieldName: 'OpportunityName', label: 'Opportunity Name or Id', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'StatusCode',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 19,
    },
    {
      fieldName: 'UseFollowUpDateRange',
      label: 'Use Follow Up Date Range',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'FollowUpDateOnOrAfter',
      label: 'Follow Up On Or After',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseFollowUpDateRange,
    },
    {
      fieldName: 'FollowUpDateOnOrBefore',
      label: 'Follow Up On Or Before',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseFollowUpDateRange,
    },
    {
      fieldName: 'UninvoicedOtherFees',
      label: 'Uninvoiced Other Fees',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'OwningOffices',
      label: 'Owning Offices',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    { fieldName: 'IsGlobal', label: 'Global', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'IsMultiOffice', label: 'Multi Office', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'PrimarySalesRep', label: 'Primary Sales Rep', className: 'col-4', type: InputTypesEnum.UserSelect },
    { fieldName: 'Owner', label: 'Owner', className: 'col-4', type: InputTypesEnum.UserSelect },
    { fieldName: 'AssignedTo', label: 'Assigned To', className: 'col-4', type: InputTypesEnum.UserSelect },
    { fieldName: 'Industry', label: 'Industry', className: 'col-4', type: InputTypesEnum.IndustryLookupItemSelect },
    {
      fieldName: 'UseCreatedOnDateRange',
      label: 'Use Created On Date Range',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'CreatedOnOrAfter',
      label: 'Created On Or After',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCreatedOnDateRange,
    },
    {
      fieldName: 'CreatedOnOrBefore',
      label: 'Created On Or Before',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCreatedOnDateRange,
    },
    {
      fieldName: 'OpportunityType',
      label: 'Opportunity Type',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 72,
    },
    {
      fieldName: 'ApprovedLogoUsage',
      label: 'Client Logo Usage Approved',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: OpportunitySearchParams.getClientApprovedOptions(),
    },
    {
      fieldName: 'ApprovedNameUsage',
      label: 'Client Name Usage Approved',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: OpportunitySearchParams.getClientApprovedOptions(),
    },
  ];

  static getClientApprovedOptions() {
    return [{ label: '', value: '' }, ...EditOpportunitySecurityChecklistWindowDescription.getClientApprovedValues()];
  }

  static iconName = 'fa-solid fa-search';
}
export default OpportunitySearchParams;
